import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PublicCampaignLocationApi,
  PublicCampaignShopApi,
  formatPublicCampaignLocationAddress,
} from '../campaign-editor/optional-setting/common-website-content.mapper';

@Component({
  selector: 'app-sms-campaign-consent-terms-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sms-campaign-consent-terms-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sms-campaign-consent-terms-modal.component.scss',
})
export class SmsCampaignConsentTermsModalComponent {
  @Input() isOpen = false;
  @Input() shop: PublicCampaignShopApi | null = null;
  @Input() location: PublicCampaignLocationApi | null = null;
  @Output() close = new EventEmitter<void>();

  get shopName(): string {
    return this.shop?.name?.trim() || 'Our shop';
  }

  get shopEmail(): string {
    return this.shop?.email?.trim() || '';
  }

  get shopContact(): string {
    return this.shop?.contact?.trim() || '';
  }

  get shopAddress(): string {
    return formatPublicCampaignLocationAddress(this.location);
  }

  get lastUpdatedLabel(): string {
    return new Date().toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
  }

  onClose(): void {
    this.close.emit();
  }
}
